<template>
  <div class="pa-2 mt-16">
    <slot></slot>
    <v-row class="justify-center">
      <v-col md="6" cols="6" class="pr-1 pb-1">
        <v-btn block color="green" dark @click="addReserva()">Agendar</v-btn>
      </v-col>
      <v-col md="6" cols="6" class="pl-1 pb-1">
        <v-btn block outlined color="error" dark @click="exportReservas">
          <v-icon left>mdi-file-pdf</v-icon>Exportar
        </v-btn>
      </v-col>
      <v-col md="12" cols="12" class="pt-0">
        <v-text-field dense outlined hide-details class="pa-0 mt-1 mb-0" label="Buscar reserva"
          v-model="filter"></v-text-field>
      </v-col>
      <v-col md="12" cols="12" class="my-0 py-0">
        <v-menu v-model="fromDateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
          offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field label="Elegir fecha" prepend-icon="mdi-calendar-clock" readonly hide-details=""
              v-model="input_date" v-on="on" @click="toggleNone = null"></v-text-field>
          </template>
          <v-date-picker locale="en-in" v-model="input_date" no-title @input="handleDateInput"></v-date-picker>
        </v-menu>

      </v-col>

      <v-col md="12" cols="12" class="mx-0 mt-0 pa-0">
        <v-btn-toggle tile shaped dense :color="this.$pgsHelper.uiConfig().mainColor" group v-model="toggleNone">
          <template v-for="(day, indexDay) in commingDays">
            <v-btn :key="indexDay" @click="
              updateSelectedDateSuggest(day.Date, indexDay);
            fromDateVal = null;
            " style="border-bottom: 1px solid #01579b" :disabled="disabledButtonIndex === indexDay">
              {{ day.Nombre }}
            </v-btn>
          </template>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <div class="lista">
      <!-- Atrasados -->
      <v-list v-if="atrasados.length > 0">
        <v-col class="pt-0 text-center">
          <h3 class="mb-0" style="color: red">Atrasados</h3>
          <v-divider></v-divider>
        </v-col>
        <v-list-item v-for="(reservaAtrasada, index) in atrasados" :key="index">
          <v-list-item-content :class="'transRed'">
            <v-row class="pt-2 pl-2">
              <v-col md="12" class="py-0">
                <v-list-item-title>{{ reservaAtrasada.cn }}</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{ reservaAtrasada.fecha }}</b></v-list-item-subtitle>
                <b>{{ reservaAtrasada.hora }}</b>
                // <b>{{ reservaAtrasada.px }} p </b>
                //
                <b>{{
                  reservaAtrasada.ms ? reservaAtrasada.ms.nm : "No especificado"
                }}</b>

                <br />
                <v-icon small>mdi-phone</v-icon>
                {{
                  reservaAtrasada.tl ? reservaAtrasada.tl : "No proporcionado"
                }}
                <br />
                <b>Notas:</b>
                {{
                  reservaAtrasada.nt ? reservaAtrasada.nt : "No proporcionado"
                }}
              </v-col>
              <v-col md="12">
                <v-btn v-if="true" color="primary" outlined class="mx-1 mt-0 mb-1 py-0"
                  @click="editReserva(reservaAtrasada)"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn color="red" outlined class="mx-1 mb-1"
                  @click="deleteReserva(reservaAtrasada)"><v-icon>mdi-delete</v-icon></v-btn>
                <v-btn color="purple" outlined class="mx-1"
                  @click="asignMesa(reservaAtrasada)"><v-icon>mdi-table-chair</v-icon></v-btn>
              </v-col>
            </v-row>
            <v-col class="pt-0 pb-0 mb-0" md="12">
              <v-divider :key="index"></v-divider>
            </v-col>
          </v-list-item-content>
        </v-list-item>
        <v-row>
          <v-col class="pt-2 mt-2 text-center" md="12">
            <h3 class="mb-0">Reservas de hoy</h3>
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-list>
      <!-- Reservas normales -->
      <v-list>


        <template v-for="(reserva, index) in reservasFiltered">
          <v-list-item v-if="!reserva.atrasada" :key="index">
            <v-list-item-content>
              <v-row class="pt-2 pl-2">
                <v-col md="12" class="py-0">
                  <v-list-item-title>{{ reserva.cn }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <b>{{ reserva.fecha }}</b></v-list-item-subtitle>
                  <b>{{ reserva.hora }}</b>
                  // <b>{{ reserva.px }} p </b>
                  //
                  <b>{{ reserva.ms ? reserva.ms.nm : "No especificado" }}</b>

                  <br />
                  <v-icon small>mdi-phone</v-icon>
                  {{ reserva.tl ? reserva.tl : "No proporcionado" }}
                  <br />
                  <b>Notas:</b>
                  {{ reserva.nt ? reserva.nt : "No proporcionado" }}
                </v-col>
                <v-col md="12">
                  <v-btn v-if="true" color="primary" outlined class="mx-1 mt-0 mb-1 py-0"
                    @click="editReserva(reserva)"><v-icon>mdi-pencil</v-icon></v-btn>
                  <v-btn color="red" outlined class="mx-1 mb-1"
                    @click="deleteReserva(reserva)"><v-icon>mdi-delete</v-icon></v-btn>
                  <v-btn color="purple" outlined class="mx-1"
                    @click="asignMesa(reserva)"><v-icon>mdi-table-chair</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-col class="pt-0" md="12">
                <v-divider :key="index"></v-divider>
              </v-col>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>
    <v-dialog v-model="showAsignMesa" persistent max-width="390" :key="dialogIndex">
      <v-card>
        <v-card-title> Asignar Mesa </v-card-title>
        <v-card-text>
          <v-form ref="accountForm">
            <v-autocomplete :items="AreasData" v-model="areaSelected" label="Area" item-text="Nombre"
              item-value="id"></v-autocomplete>

            <v-autocomplete :items="comp_mesa" v-model="openTableData.Contenedor.Id" label="Mesa" :rules="rules.require"
              item-text="Nombre" item-value="id">
              <template v-slot:selection="data">
                <v-chip v-bind="data.attrs" :input-value="data.selected"
                  :color="data.item.Estado.E == 1 ? 'success' : 'primary'">
                  {{ data.item.Nombre }} -
                  {{ data.item.Estado.E == 1 ? "Abierto" : "Cerrado" }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-chip large :color="data.item.Estado.E == 1 ? 'success' : 'primary'">
                    {{ data.item.Nombre }} -
                    {{ data.item.Estado.E == 1 ? "Abierto" : "Cerrado" }}
                    {{
                      data.item.Estado.E == 1
                        ? "|| Mesero:" + data.item.Estado.Mesero.Nom
                        : ""
                    }}
                  </v-chip>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <v-text-field v-model="openTableData.Comensales" type="number" label="Comensales"
              :rules="rules.comensales" />
            <v-autocomplete :items="comp_meseros" :rules="rules.require" v-model="openTableData.Mesero.Id"
              label="Mesero" item-text="Nombre" item-value="id"></v-autocomplete>
            <v-autocomplete :rules="rules.require" v-model="openTableData.Departamento" label="Departamento"
              :items="modulos">
            </v-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="showAsignMesa = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text @click="asignarMesa()" :loading="loader">
            Asignar mesa
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <modal v-model="showModal" title="Agendar reserva" :showFooter="false" :fullscreen="true" :customClass="'classMod'">
      <MesaForm :edit="editMode" :key="formIndex" :dataEdit="editData" :getAybContenedores="contenedores"
        :contendeoresValidos="contendeoresValidos" :areas="areas" :AreasData="AreasData" :indexMapa="indexMapa"
        :reservations="reservations" :Departamento="aybDepto" @reloadCloseReserva="closeAndReloadReservas"></MesaForm>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReservasAyB from "../../../../clases/PdfMakers/ReservasAYB.js";
import MesaForm from "./MesaForm.vue";
import * as Sentry from "@sentry/vue";
import TableRestaurant from "../../../../clases/TableRestaurant";

export default {
  name: "BookingMesa",
  components: {

    MesaForm,
  },
  props: ["areas", "AreasData", "indexMapa", "contenedores", "mapas", "Departamento", "aybDepto"],
  data() {
    return {
      keyCounter: 0,
      showAsignMesa: false,
      areaSelected: "",
      dialogIndex: 1,
      meseros: [],
      openTableData: {
        Contenedor: { Id: "", Nom: "" },
        Comensales: 1,
        Mesero: { Id: "", Nom: "" },
        Cliente: { Id: "PUBLICOGENERAL", Nom: "Publico general", Apd: "" },
        Departamento: null,
      },
      rules: {
        require: [(value) => !!value || "Campo obligatorio"],
        comensales: [
          (value) => !!value || "Campo obligatorio",
          (value) => value > 0 || "Ingrese un número válido",
        ],
      },
      loader: false,

      showModal: false,
      editMode: false,
      editData: {},
      formIndex: 1,

      filter: "",

      reservations: [],
      reservacion: {},

      configTime: {},
      daysRules: [],
      actualDate: moment().format("YYYY-MM-DD"),
      date: moment().format("YYYY-MM-DD"),
      input_date: moment().format("YYYY-MM-DD"),

      fromDateMenu: false,
      fromDateVal: null,
      toggleNone: 0,
      disabledButtonIndex: null,

      sendReservationValues: false,
    };
  },
  methods: {

    async closeAndReloadReservas() {
      this.showModal = false;
      await this.getReservas();
      this.changeFunction();
    },

    deleteReserva(reserva) {
      const fecha = reserva.fr.split("_")[0];
      const fechaHoraConcatenada = fecha + "_" + reserva.hora + ":00";
      let datos = {
        id: reserva.id,
        cn: reserva.cn,
        fr: fechaHoraConcatenada,
        px: Number(reserva.px),
        ms: reserva.ms
          ? {
            id: reserva.ms.id ? reserva.ms.id : null,
            nm: reserva.ms.nm ? reserva.ms.nm : null,
          }
          : null,
        tl: reserva.tl ? reserva.tl : null,
        nt: reserva.nt ? reserva.nt : null,
        et: "cancelado",
        tenant: this.$store.getters.getFirebaseApp.tenant,
        dp: this.aybDepto,
      };

      this.$swal({
        title: "Eliminar reserva",
        text: "La reserva se eliminará para siempre",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.getFirebaseApp.fba
            .call("AYB-Reservas-updateReserva", datos)
            .then(async (result) => {
              if (result.data.ok) {
                this.$swal({
                  title: "Eliminado",
                  text: "Reserva eliminada correctamente",
                  icon: "success",
                });
                await this.getReservas();
                this.changeFunction();
                this.$emit("reloadBookings")
              } else {
                this.$swal(
                  "Error eliminando reserva",
                  result.value.data.error,
                  "error"
                );
              }
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      });
      this.changeFunction();
    },
    exportReservas() {
      let reservasArea = {};
      this.reservasFiltered.forEach(reserva => {
        const mesaId = reserva.ms ? reserva.ms.id : null;
        let mesa = mesaId ? this.$pgsHelper.getById(this.contenedores, "Id", mesaId) : null;
        const areaId = mesa && mesa.Area ? mesa.Area : "SinArea";
        if (!reservasArea[areaId]) {
          const areaNombre = areaId !== "SinArea"
            ? (this.AreasData.find((a) => a.Id == areaId)?.Nombre || `Área ${areaId}`)
            : "Mesa no asignada";

          reservasArea[areaId] = {
            Rva: [],
            Nombre: areaNombre
          };
        }
        if (!reserva.atrasada) {
          reservasArea[areaId].Rva.push(reserva);
        }
      });

      console.log("reservas por area", reservasArea);
      let mainData = {
        FI: this.input_date,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        reservas: reservasArea,
        TITLE: "Reporte de Reservas AYB"
      };
      let docData = ReservasAyB.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    addReserva() {
      this.formIndex++;
      this.editMode = false;
      this.showModal = true;
    },
    editReserva(reserva) {
      this.formIndex++;
      this.editMode = true;
      this.editData = reserva;
      this.showModal = true;
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    asignMesa(reserva) {
      this.dialogIndex++;
      this.areaSelected = "";
      this.showAsignMesa = true;
      this.openTableData.Contenedor.Id = reserva.ms?.id;
      this.openTableData.Contenedor.Nom = reserva.ms?.nm;
      this.openTableData.Comensales = reserva.px;
      this.openTableData.Cliente.Apd = reserva.cn;
      this.reservacion = reserva;
    },

    async asignarMesa() {
      if (this.$refs.accountForm.validate()) {
        this.loader = true;
        try {
          const data = this.$pgsHelper.getById(
            this.contenedores,
            "id",
            this.openTableData.Contenedor.Id
          );

          if (data) {
            let datos = {};
            let func = "AYB-Mesas-abrirMesa";
            if (data.Estado.E == 1) {
              datos = {
                Contenedor: {
                  Id: this.openTableData.Contenedor.Id,
                  Nombre: this.openTableData.Contenedor.Nom,
                },
                Comensales: this.openTableData.Comensales,
                Mesero: {
                  Id: this.openTableData.Mesero.Id,
                  Nombre: this.openTableData.Mesero.Nom,
                },
                Cliente: {
                  Id: this.openTableData.Cliente.Id,
                  Nombre: "",
                  Apodo: this.openTableData.Cliente.Apd,
                },
                Catalogo: [],
                Estatus: 1,
                Departamento: this.openTableData.Departamento,
                DeptoAYB: this.aybDepto,
              };
              func = "AYB-Cuentas-createCuenta";
            } else if (data.Estado.E == 0) {
              datos = this.openTableData;
              datos.Cliente.Nom = "";
              datos.Mesero.Nom = this.$pgsHelper.getById(
                this.meseros,
                "id",
                datos.Mesero.Id
              ).Nombre;
              (datos.Contenedor.Nom = this.openTableData.Contenedor.Nom),
                (datos.Comensales = Number(datos.Comensales));
              datos.Departamento = this.openTableData.Departamento;
              datos.DeptoAYB = this.aybDepto;
              func = "AYB-Mesas-abrirMesa";
            }

            await this.$store.getters.getFirebaseApp.fba
              .call(func, datos)
              .then((result) => {
                if (result.data.ok) {
                  this.openTableData = {
                    Contenedor: { Id: "", Nom: "" },
                    Comensales: 1,
                    Mesero: { Id: "", Nom: "" },
                    Cliente: { Id: "PUBLICOGENERAL", Nom: "", Apd: "" },
                  };
                  this.updateAsignado(this.reservacion);
                  this.showAsignMesa = false;
                  this.$emit("reloadBookings")
                } else {
                  this.loader = false;
                  this.$swal(
                    "Error abriendo cuenta",
                    result.data.error,
                    "error"
                  );
                  Sentry.captureMessage(
                    "Error abriendo cuenta " + result.data.error
                  );
                }
              })
              .catch((error) => {
                this.loader = false;
                this.$swal("Error", "Error enviando informacion", error);
              });
          }
        } catch (e) {
          this.loader = false;
          this.$swal("Error abriendo cuenta", e.message, "error");
          Sentry.captureMessage("Error abriendo cuenta " + e.message);
          console.log(e.message);
        }
      }
    },

    async getMeserosAB() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "AYB/Meseros"
      );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },

    async updateAsignado(reserva) {
      const fecha = reserva.fr.split("_")[0];
      const fechaHoraConcatenada = fecha + "_" + reserva.hora + ":00";
      let datos = {
        id: reserva.id,
        cn: reserva.cn,
        fr: fechaHoraConcatenada,
        px: Number(reserva.px),
        ms: reserva.ms
          ? {
            id: reserva.ms.id ? reserva.ms.id : null,
            nm: reserva.ms.nm ? reserva.ms.nm : null,
          }
          : null,
        tl: reserva.tl ? reserva.tl : null,
        nt: reserva.nt ? reserva.nt : null,
        et: "cancelado",
        tenant: this.$store.getters.getFirebaseApp.tenant,
        dp: this.aybDepto,
      };
      await this.$store.getters.getFirebaseApp.fba
        .call("AYB-Reservas-updateReserva", datos)
        .then((result) => {
          if (result.data.ok) {
            // Descomentar por si se desea un alert
            // this.$swal("Cuenta creada", "Mesa asignada con éxito");
            this.getReservas();
            this.loader = false;
            this.reservacion = {};
          } else {
            this.$swal("Error abriendo cuenta", "error");
            this.reservacion = {};
          }
        });
      this.changeFunction();
    },

    handleDateInput() {
      /*this.fromDateMenu = false;

      //this.input_date = moment(this.fromDateVal,"YYYY-MM-DD").format("YYYY-MM-DD");
      this.disabledButtonIndex = null; // Habilita todos los botones*/
      this.enviarDatos();
    },
    updateSelectedDateSuggest(day, index) {
      this.loadingData = true;
      this.date = day;
      this.input_date = day;
      this.fromDateVal = null;
      this.disabledButtonIndex = index; // Desactiva solo el botón seleccionado
      this.enviarDatos();
    },

    async getReservas() {
      this.reservations = [];
      const equal =
        "D" + this.aybDepto + "~Dreservado";
      const database = this.$store.getters.getFirebaseApp.database;
      /*let data = await this.getFirebaseApp.database
        .ref("AYB/Reservas")
        .orderByChild("_I/test")
        .equalTo(equal)
        .once("value");*/
      let data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "AYB/Reservas", [
        database.orderByChild("_I/test"),
        database.equalTo(equal),
      ]
      );
      if (data.exists()) {
        let reservas = Object.entries(data.val());
        reservas.forEach((element) => {
          this.reservations.push({ id: element[0], ...element[1] });
        });
      }
      this.keyCounter++
      this.$forceUpdate()
    },

    enviarDatos() {
      try { this.$emit("inputDate-enviado", moment(this.input_date)) } catch (e) { console.log(e) }

    },
    changeFunction() {
      //Esta función sirve para emitir cambios al main para la vista del mapa
      this.$emit("changeFunction");
    },
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    ...mapGetters("dataLists", [
      "getClientes",
    ]),
    modulos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    fromDateDisp() {
      return this.fromDateVal
        ? moment(this.fromDateVal).format("YYYY/MM/DD")
        : "";
    },
    commingDays() {
      try {
        let disable_dates = [];
        let open_dates = [];
        let weekDay = [];
        this.daysRules.forEach((element) => {
          if (element.data === false) {
            disable_dates.push(element.date, "YYYY-MM-DD");
          } else {
            open_dates.push(element.date);
          }
        });
        let numberToShow = 3;
        let days = [];

        let actual = moment();
        for (var i = 0; days.length <= numberToShow; i++) {
          let hoy = moment();
          let isToday = false;
          if (actual.format("YYYY-MM-DD") == hoy.format("YYYY-MM-DD")) {
            isToday = true;
          }

          if (!weekDay.includes(actual.day())) {
            days.push({
              Nombre: isToday ? "Hoy" : actual.format("ddd - DD"),
              Date: actual.format("YYYY-MM-DD"),
            });
          }

          if (
            weekDay.includes(actual.day()) &&
            open_dates.includes(actual.format("YYYY-MM-DD"))
          ) {
            days.push({
              Nombre: isToday ? "Hoy" : actual.format("ddd - DD"),
              Date: actual.format("YYYY-MM-DD"),
            });
          }
          actual.add(1, "days");
        }

        return days;
      } catch (e) {
        return [];
      }
    },

    contendeoresValidos() {
      let cont = {};
      this.mapas.forEach((mapa) => {
        mapa.Mapa.forEach((map) => {
          cont[map.id] = true;
        });
      });
      return cont;
    },

    comp_mesa() {
      let data = TableRestaurant.getAllTables(this.contenedores);

      let cont = data.map((cont) => {
        if (this.areaSelected != "") {
          if (this.areaSelected == cont.Area) {
            if (this.contendeoresValidos[cont.id]) {
              return cont;
            }
          }
        } else {
          if (this.contendeoresValidos[cont.id]) {
            return cont;
          }
        }
      });
      let sortedCont = cont.sort((a, b) => {
        return a.Nombre.localeCompare(b.Nombre, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
      return sortedCont;
    },
    comp_meseros() {
      let meseros = [];
      this.meseros.forEach((mesero) => {
        if (mesero.Deptos) {
          if (
            mesero.Deptos[this.aybDepto] &&
            mesero.Activo
          ) {
            meseros.push(mesero);
          }
        }
      });

      return meseros;
    },

    reservasFiltered() {
      this.$pgsHelper.forceReactivity(this.keyCounter)
      let reservas = [];
      let sortedReserva = [];

      // Filtrar por texto si el filtro no está vacío
      if (this.filter !== "") {
        const filterNoAccents = this.removeAccents(this.filter).toUpperCase();
        reservas = this.reservations.filter((reserva) =>
          this.removeAccents(reserva.cn).toUpperCase().includes(filterNoAccents)
        );
      } else {
        reservas = this.reservations;
      }

      // Añadir la propiedad atrasada y extraer fecha y hora
      reservas = reservas.map((reserva) => {
        const reservaDate = moment(reserva.fr, "YYYY/MM/DD_HH:mm:ss");
        return {
          ...reserva,
          atrasada: reservaDate.isBefore(moment(), "day"),
          fecha: reservaDate.format("YYYY/MM/DD"),
          hora: reservaDate.format("HH:mm"),
        };
      });

      // Filtrar por la fecha ingresada (si hay) y añadir las atrasadas
      if (this.input_date) {
        const esHoy = moment(this.input_date).isSame(moment(), "day");
        if (esHoy) {
          reservas = reservas.filter((reserva) => {
            return (
              moment(reserva.fr, "YYYY/MM/DD").isSame(this.input_date, "day") ||
              reserva.atrasada
            );
          });
        } else {
          reservas = reservas.filter((reserva) => {
            return moment(reserva.fr, "YYYY/MM/DD").isSame(
              this.input_date,
              "day"
            );
          });
        }
      }

      reservas = reservas.filter((reserva) => {
        return reserva.et != "asignado" && reserva.et != "cancelado";
      });

      // Ordenar las reservas por fecha y hora
      sortedReserva = this.$_.orderBy(
        reservas,
        (reserva) =>
          moment(
            reserva.fecha + " " + reserva.hora,
            "YYYY/MM/DD HH:mm"
          ).toDate(),
        "asc"
      );

      return sortedReserva;
    },

    atrasados() {
      this.$pgsHelper.forceReactivity(this.keyCounter)
      let atrasados = [];
      this.reservasFiltered.map((reserva) => {
        if (reserva.atrasada) {
          atrasados.push(reserva);
        }
      });
      return atrasados;
    },
  },
  async mounted() {
    await this.getReservas()
    await this.getMeserosAB()
  },
  beforeUnmount() {
    this.changeFunction();
  },
};
</script>

<style scoped>
.lista {
  margin-top: 2vh;
  height: calc(70vh);
  outline: auto;
  overflow: auto;
  margin-bottom: 300px;
  padding-bottom: 90px;
}

.fechaBtn {
  max-width: 32%;
  padding-top: 8px !important;
}

.fechaBtn>>>.v-btn__content {
  max-width: 100%;
}

.transRed {
  background-color: rgba(255, 0, 0, 0.144);
}
</style>
